<!--理论入口-->
<template>
  <div class="theoryEntrance">
    <!--顶部文字介绍-->
    <div class="top-layer">
      <div class="top-layer-title">python量化投资理论演练</div>
      <div class="top-layer-desc">
        本课程通过XXXX课程描述XXXX课程描述XXXX课程描述XXXX课程描述XXXX课程描述XXXX课程描述XXXX课程描述XXXX课程描述XXXX课程描述，
        XXXX课程描述XXXX课程描述XXXX课程描述，XXXX课程描述XXXX课程描述XXXX课程描述XXXX课程描述XXXX课程描述XXXX课程描述XXXX课程，
        XXXX课程描述XXXX课程描述XXXX课程描述。
      </div>
    </div>
    <!--底部跳转-->
    <div class="content-layer">
      <div class="item" @click="Jump('/theoryPracticeList')">
        <p>试卷练习</p>
      </div>
      <div class="item" @click="Jump('/theoryTestList')">
        <p>理论考试</p>
      </div>
      <div class="item" @click="Jump('/theoryHistoryList')">
        <p>做题历史</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () { },
  methods: {}
}
</script>

<style scoped lang="less">
.theoryEntrance {
  padding: 20px 50px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .top-layer {
    width: 60%;
    max-width: 1200px;
    padding: 50px;

    .top-layer-title {
      height: 60px;
      line-height: 60px;
      font-size: 48px;
      text-align: center;
      letter-spacing: 3px;
      padding: 50px 0;
      color: transparent;
      /* 设置文字颜色为透明 */
      background-image: linear-gradient(to right, #1E84EC, #B5F4FD);
      /* 设置背景为渐变色 */
      -webkit-background-clip: text;
      /* WebKit 浏览器专用属性，使背景剪切至文本 */
      background-clip: text;
    }

    .top-layer-desc {
      font-size: 19px;
      text-indent: 42px;
      line-height: 1.6;
      text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.4);
      color: #fff;
      letter-spacing: 2px;
    }
  }

  .content-layer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .item {
      margin-right: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      box-sizing: border-box;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: 0 0;

      background-image: url("~@imgs/home/btn-black.png");
      width: 278px;
      height: 71px;
      transition: background-image 0.3s ease;

      p {
        font-size: 20px;
        color: #fff;
      }

      &:hover {
        background-image: url('~@imgs/home/btn-blue.png');

        p {
          color: #000;
        }
      }
    }
  }
}
</style>
